/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import throttle from 'lodash/throttle';

export function useDebounce<T>(value: T, delay: number) {
    const [debouncedValue, setDebouncedValue] = React.useState(value);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

export function useThrottle<T>(value: T, delay: number = 750) {
    const [throttledValue, setThrottledValue] = React.useState(value);

    React.useEffect(() => {
        const throttled = throttle((v) => {
            setThrottledValue(v);
        }, delay);

        throttled(value);

        return () => {
            throttled.cancel();
        };
    }, [value, delay]);

    return throttledValue;
}
